// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"384":"3bbe7ef1","706":"6a1103e8"}[chunkId] + ".js";
};